/** Выбор готовых вопросов: переживает смену фильтров, страниц и перезагрузку (спецификация, п. 5.4). */
import type { QuestionKind } from './model';

const key = (testId: number): string => `tw.pick.${testId}`;

export function loadSelection(testId: number): number[] {
  try {
    const parsed: unknown = JSON.parse(window.sessionStorage.getItem(key(testId)) ?? '[]');
    return Array.isArray(parsed) ? parsed.filter((value): value is number => Number.isInteger(value)) : [];
  } catch {
    return [];
  }
}

export function saveSelection(testId: number, ids: number[]): void {
  try {
    window.sessionStorage.setItem(key(testId), JSON.stringify(ids));
  } catch {
    /* хранилище недоступно (приватное окно): выбор живёт только на экране */
  }
}

export function clearSelection(testId: number): void {
  try {
    window.sessionStorage.removeItem(key(testId));
  } catch {
    /* см. выше */
  }
}

export function toggleId(ids: number[], id: number): number[] {
  return ids.includes(id) ? ids.filter((value) => value !== id) : [...ids, id];
}

export function mergeIds(ids: number[], more: number[]): number[] {
  return Array.from(new Set([...ids, ...more]));
}

/** Минимум, который нужен мастеру, чтобы показать выбранные готовые вопросы после перезагрузки. */
export interface PickedRow {
  question_id: number;
  text: string;
  type: QuestionKind;
}

const rowsKey = (selectionKey: number): string => `tw.pick.rows.${selectionKey}`;

export function loadPickedRows(selectionKey: number): PickedRow[] {
  try {
    const parsed: unknown = JSON.parse(window.sessionStorage.getItem(rowsKey(selectionKey)) ?? '[]');
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (row): row is PickedRow => Boolean(row)
        && Number.isInteger((row as PickedRow).question_id)
        && typeof (row as PickedRow).text === 'string'
        && typeof (row as PickedRow).type === 'string',
    );
  } catch {
    return [];
  }
}

export function savePickedRows(selectionKey: number, rows: PickedRow[]): void {
  try {
    window.sessionStorage.setItem(
      rowsKey(selectionKey),
      JSON.stringify(rows.map(({ question_id, text, type }) => ({ question_id, text, type }))),
    );
  } catch {
    /* хранилище недоступно: выбор живёт только на экране */
  }
}

export function clearPickedRows(selectionKey: number): void {
  try {
    window.sessionStorage.removeItem(rowsKey(selectionKey));
  } catch {
    /* см. выше */
  }
}
